import React, { Component } from 'react';
import { APP_URL_API } from '../../../setup/configs'
import Header from '../../common/Header';
import OrganizationsList from '../../organization/List';
import SearchBox from '../../common/SearchBox';
import CategorySelect from '../../common/CategorySelect';
import FilterButtons from '../../common/FilterButtons';
import axios from 'axios';
import AuthService from '../../auth/AuthService';
import withAuth from '../../auth/withAuth';

/*

OrganizationsOverview is wrapped in a HoC (Higher order component). This component takes care of checking if user is
logged in and retrieves the user type. If user is not logged in, he/she is sent to the login form.

OrganizationsOverview renders a list of communities and congregations with a search field and filter options.

Its important to state that all organizations are loaded when this component is mounted, even if only 10 organizations are shown at first.
This makes searching and filtering extremely fast.

*/

class OrganizationsOverview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            category: '',
            value: '',
            filter: '',
            page: 1,
            listHeader: '',
            showMoreButton: false
        }
    this.handleChange = this.handleChange.bind(this);
    this.selectCategory = this.selectCategory.bind(this);
    this.selectFilter = this.selectFilter.bind(this);
    this.showMore = this.showMore.bind(this);
  }

    handleChange(event) {
        this.setState({value: event.target.value, filter: ''});
    }

    selectCategory(e) {
        this.setState({
            category: e.target.value,
            listHeader: e.target.name,
            page: 1,
            filter: ''});
    }

    showMore() {
        this.setState({page: this.state.page + 1});
    }

    selectFilter(e) {
        this.setState({
            category: null,
            value: '',
            filter: e.target.value,
            listHeader: e.target.name
        });
    }

    onHandleShowMoreButton = (totalNumberOfResults, currentNumberOfResults) => {
        this.setState({
            showMoreButton: totalNumberOfResults>currentNumberOfResults,
        })
    }

    componentDidMount() {
        if(this.props.user.type==='admin') {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'organizations';

        this.serverRequest =
            axios
                .get(url, {headers: config})
                .then(function(result) {
                    this.setState({
                        data: result.data.data
                    });
                }.bind(this))
        } else {
            this.props.history.replace('/admin/');
        }
    }

    render() {
        return (
            <div>
                <Header user={this.props.user} history={this.props.history}>
                  {this.props.user.type === 'admin' && <nav className="navigation">
                    <ul className="navigation__list">
                      <li className="navigation__listitem active"><a href="/admin/organizations/">Oversigt</a></li>
                      <li className="navigation__listitem"><a href="/admin/organization/create">Opret</a></li>
                      <li className="navigation__listitem"><a href="/admin/organizations/settings">Indstillinger</a></li>
                    </ul>
                  </nav>}
                </Header>

                <div className="content-wrapper">
                    <h3 className="list-header">Trossamfund og menigheder</h3>
                    <div className="searchAndList">
                        <SearchBox
                            onChange={this.handleChange}
                            value={this.state.value}
                            placeholder="Søg på trossamfund, menighed, adresse, navn, e-mail eller CVR nr." />
                        {this.state.data ? <OrganizationsList
                            searchString={this.state.value}
                            category={this.state.category}
                            listHeader={this.state.listHeader}
                            filter={this.state.filter}
                            page={this.state.page}
                            showMore={this.showMore}
                            onHandleShowMoreButton={this.onHandleShowMoreButton}
                            organizationsFromAPI={this.state.data} /> : <div>Indlæser...</div>}
                    </div>
                    <div className="filters">
                        <CategorySelect
                            selectCategory={this.selectCategory}
                            value={this.state.category} />
                        <FilterButtons
                            selectFilter={this.selectFilter}
                            value={this.state.filter} />
                    </div>
                </div>
            </div>
        );
    }
}

export default withAuth(OrganizationsOverview);


// WEBPACK FOOTER //
// ./src/modules/admin/organization/Overview.js